import { render } from "./ReportStaticText.vue?vue&type=template&id=b5829eda&scoped=true&ts=true"
import script from "./ReportStaticText.vue?vue&type=script&lang=ts"
export * from "./ReportStaticText.vue?vue&type=script&lang=ts"

import "./ReportStaticText.vue?vue&type=style&index=0&id=b5829eda&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b5829eda"]])

export default __exports__